export default [
  // 首页
  {
    path: '/',
    name: 'Index',
    meta: {
      IndexHeader: true,
      itemIndex: 0,
      needScroll: true
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index')
  },
  // 首页里面的一些详情列表
  {
    path: '/IndexDetails/:listName',
    name: 'IndexDetails',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/index-details')
  },
  // 主页
  {
    path: '/GameData/:gameName',
    name: 'GameData',
    meta: {
      IndexHeader: true,
      itemIndex: 1,
      needScroll: true
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/game-data')
  },
  // 关于我们
  {
    path: '/contact',
    name: 'contact',
    meta: {
      IndexHeader: true,
      itemIndex: 0,
      needScroll: true
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/contact-us.vue')
  },
  // 投诉建议
  {
    path: '/complaint',
    name: 'complaint',
    meta: {
      IndexHeader: true,
      itemIndex: 0,
      needScroll: true
    },
    component: () =>
      import(/* webpackChunkName: "Index" */ '@/components/index/complaint.vue')
  },
  // skt集团
  {
    path: '/sktGroup',
    name: 'sktGroup',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "Index" */ '@/components/index/sktGroup.vue')
  },
  // 隐私协议
  {
    path: '/privateInfo',
    name: 'privateInfo',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/privateInfo.vue')
  },
  // 用户协议
  {
    path: '/profile',
    name: 'profile',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/profile.vue')
  },
  // 新用户协议
  {
    path: '/newprofile',
    name: 'newprofile',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/agreements/newprofile.vue')
  },
  // 新隐私协议
  {
    path: '/newprivateInfo',
    name: 'newprivateInfo',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/agreements/newprivateInfo.vue')
  },
  // 儿童用户协议
  {
    path: '/childrenProfile',
    name: 'childrenProfile',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/agreements/childrenProfile.vue')
  },
  // 儿童隐私协议
  {
    path: '/childrenPrivateInfo',
    name: 'childrenPrivateInfo',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/index/agreements/childrenPrivateInfo.vue')
  },
  {
    path: '/details/:name',
    name: 'details',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/bloom-seo/index.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/index.js